// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nIJ_","content":"styles_content__3pNHT"};